import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { H1, Button, Spinner, Span } from 'shared';
import GreenCheckIcon from 'images/utility-icons/cil-check-circle-green.svg';
import { DisclosureFooter } from '../components';
import SummaryCard from '../components/SummaryCard';
import { useAuthorizationToken, useFlexFinalizeData } from '../hooks';
import { getPathWithToken } from '../utils';
function NextSteps() {
    const history = useHistory();
    const { path } = useRouteMatch();
    const authorizationToken = useAuthorizationToken();
    const { finalizeData, isLoading } = useFlexFinalizeData(authorizationToken);
    const hasMultiplePaymentOptions = !!finalizeData?.suggestedMonthlyPayment;
    const getNextStepButton = () => {
        if (!finalizeData?.signingFlowStatus) {
            return {
                label: 'Get Started',
                path: getPathWithToken('/autopay', authorizationToken),
            };
        }
        const status = finalizeData.signingFlowStatus;
        switch (status) {
            case 'connect_bank_account':
                return {
                    label: 'Get Started',
                    path: getPathWithToken('/autopay', authorizationToken),
                };
            case 'setup_initial_payment':
                return {
                    label: 'Continue',
                    path: getPathWithToken('/autopay-auth', authorizationToken),
                };
            case 'sign_agreement':
                return {
                    label: 'Continue',
                    path: getPathWithToken('/sign-agreement', authorizationToken),
                };
            default:
                return {
                    label: 'Get Started',
                    path: getPathWithToken('/autopay', authorizationToken),
                };
        }
    };
    const nextStepButton = getNextStepButton();
    const isStepCompleted = (stepNumber) => {
        if (!finalizeData?.signingFlowStatus) {
            return false;
        }
        const status = finalizeData.signingFlowStatus;
        if (status === 'setup_initial_payment' && stepNumber === 1) {
            return true;
        }
        if (status === 'sign_agreement' && (stepNumber === 1 || stepNumber === 2)) {
            return true;
        }
        return false;
    };
    useEffect(() => {
        if (finalizeData?.signingFlowStatus === 'sign_success') {
            const signSuccessPath = getPathWithToken('/sign-success', authorizationToken);
            history.push(signSuccessPath);
        }
    }, [finalizeData, history, path, authorizationToken]);
    return (_jsx(_Fragment, { children: !isLoading && finalizeData ? (_jsxs("div", { className: "next-steps-container", children: [_jsx(H1, { variant: "headline-large", children: "Just A Few More Steps" }), _jsx(SummaryCard, { ...finalizeData }), _jsx("hr", { className: "flex-finalize-divider" }), _jsx("div", { className: "next-steps-section", children: _jsxs("ol", { className: "next-steps-list", children: [_jsx("li", { children: _jsxs("div", { className: "flex align-center", children: [isStepCompleted(1) ? (_jsx("img", { src: GreenCheckIcon, alt: "Completed", className: "mar-right-2 green-check-icon" })) : (_jsx(Span, { variant: "body-medium", children: "1." })), ' ', "\u00A0 \u00A0", ' ', _jsx(Span, { variant: "body-medium", children: "Add Bank Account" })] }) }), _jsx("li", { children: _jsxs("div", { className: "flex align-center", children: [isStepCompleted(2) ? (_jsx("img", { src: GreenCheckIcon, alt: "Completed", className: "mar-right-2 green-check-icon" })) : (_jsx(Span, { variant: "body-medium", children: "2." })), ' ', "\u00A0 \u00A0", ' ', _jsx(Span, { variant: "body-medium", children: "Set Up Autopay" })] }) }), _jsx("li", { children: _jsxs("div", { className: "flex align-center", children: [isStepCompleted(3) ? (_jsx("img", { src: GreenCheckIcon, alt: "Completed", className: "mar-right-2 green-check-icon" })) : (_jsx(Span, { variant: "body-medium", children: "3." })), ' ', "\u00A0 \u00A0 ", _jsx(Span, { variant: "body-medium", children: "Review Terms" })] }) })] }) }), _jsx("div", { className: "flex-center mar-t-32", children: _jsx(Button, { type: "submit", className: "button-primary button-warn button-warn-alp-flex w100", onClick: () => history.push(nextStepButton.path), children: nextStepButton.label }) }), _jsx(DisclosureFooter, { termLength: finalizeData.product?.termLength, loanAmount: finalizeData.loanAmount, calculatedApr: finalizeData.calculatedApr, promotionalPeriod: hasMultiplePaymentOptions
                        ? finalizeData.product?.promotionalPeriod
                        : undefined })] })) : (_jsx("div", { className: "pre-qualification-installment credit-portal pad-20", children: _jsx("div", { className: "text-center", children: _jsx(Spinner, {}) }) })) }));
}
export default NextSteps;
